/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import React, { memo } from 'react';

import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

export interface IControlledInputProps {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  showMark?: boolean;
  dataTestId?: string;
  styleClass?: any;
  skippable?: boolean;
}

const ControlledInput = ({ label, required, showMark, children, dataTestId, styleClass = '', skippable = false }: IControlledInputProps) => {
  const classes = useStyles();
  const requiredMark = showMark && <span className={required ? classes.requiredMark : classes.skippableMark}>{required ? '*' : '**'}</span>;

  return (
    <FormControl className={`${classes.formControl} ${styleClass}`}>
      <Typography color="secondary" variant="caption" align="left" component="h1">
        {label} {(required || skippable) && requiredMark}
      </Typography>
      <div data-testid={dataTestId}>{children}</div>
    </FormControl>
  );
};

export default memo(ControlledInput);
